// extracted by mini-css-extract-plugin
module.exports = {"container":"Banner-module--container--26d9e","content":"Banner-module--content--38Tkt","animate":"Banner-module--animate--398et","frame":"Banner-module--frame--2XfKk"};